// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as DeccoUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.mjs";
import * as ResponseHandler$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.mjs";
import * as FareEstimateErrorConfigV1$PorterinFeature from "./FareEstimateErrorConfigV1.mjs";
import * as FareEstimateOmsEntityMapper$PorterinFeature from "../../../../shared/fare-estimate/repo/repo-mapper/FareEstimateOmsEntityMapper.mjs";
import * as FareEstimateValidatorApiModel$PorterinFeature from "../../../../shared/fare-estimate/repo/api-model/FareEstimateValidatorApiModel.mjs";

function execute(json) {
  var token = JSON.parse(JSON.stringify(json));
  return token.response.fare_estimate_token;
}

var FareEstimateResultHashStateMapper = {
  execute: execute
};

var execute$1 = execute;

var FareEstimateResultHashApiConfig = {
  execute: execute$1
};

var partial_arg = ResponseHandler$Catalyst.ResponseConverter;

var FareEstimateResultHashApiResponseConverter = partial_arg(FareEstimateResultHashApiConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

function getCallbackRequestData(data) {
  return {
          result: data.result,
          prev_callback_req_id_present: data.prev_callback_req_id_present,
          callback_request_id: data.callback_request_id,
          is_existing_cust: data.is_existing_cust,
          brand: data.brand,
          lead_entry_created: Belt_Option.getWithDefault(data.lead_entry_created, false),
          send_unregistered_event: Belt_Option.getWithDefault(data.send_unregistered_event, false)
        };
}

function apiModelToState(data) {
  return {
          redirect_url: data.fare_estimate_url,
          callback_request_data: getCallbackRequestData(data.callback_request_response)
        };
}

function execute$2(json) {
  return apiModelToState(DeccoUtils$Catalyst.resolveResult(FareEstimateValidatorApiModel$PorterinFeature.t_decode(json), "FareEstimateResponseConfig.res"));
}

var FareEstimateResultStateMapper = {
  getCallbackRequestData: getCallbackRequestData,
  apiModelToState: apiModelToState,
  execute: execute$2
};

var execute$3 = execute$2;

var FareEstimateResultApiConfig = {
  execute: execute$3
};

var partial_arg$1 = ResponseHandler$Catalyst.ResponseConverter;

var FareEstimateResultApiResponseConverter = partial_arg$1(FareEstimateResultApiConfig, {
      execute: FareEstimateErrorConfigV1$PorterinFeature.execute
    });

var execute$4 = FareEstimateOmsEntityMapper$PorterinFeature.execute;

var OmsApiConfig = {
  execute: execute$4
};

export {
  FareEstimateResultHashStateMapper ,
  FareEstimateResultHashApiConfig ,
  FareEstimateResultHashApiResponseConverter ,
  FareEstimateResultStateMapper ,
  FareEstimateResultApiConfig ,
  FareEstimateResultApiResponseConverter ,
  OmsApiConfig ,
}
/* FareEstimateResultHashApiResponseConverter Not a pure module */
